import React from 'react';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import { validateInputOnBlur, validateInputOnInput, errorTypesText } from '../../../../../../../util/validation';
import '../../../../../../../styles/master/plugins/_date-picker.scss';

export class Contest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        email: { value: '', valid: true, required: true },
        firstName: { value: '', valid: true, required: true },
        lastName: { value: '', valid: true, required: true },
        dob: { value: undefined, valid: true, required: this.props.widgetData.requestBday ?? false },
        intl: { value: '', valid: true, required: true },
        address1: { value: '', valid: true, required: true },
        city: { value: '', valid: true, required: true },
        stateCode: { value: '', valid: true, required: true },
        zip: { value: '', valid: true, required: true },
        phone: { value: '', valid: true, required: true },
        response1: {
          value: this.props.passedAppFunctions.getURLParamValue('r1') || '',
          valid: true,
          required: this.props.widgetData.options[0]?.required,
        },
        response2: {
          value: this.props.passedAppFunctions.getURLParamValue('r2') || '',
          valid: true,
          required: this.props.widgetData.options[1]?.required,
        },
      },
      contestId: this.props.widgetData.contestId,
      restrictions: this.props.widgetData.restrictions,
      dob: undefined,
      receiveEmails: true,
      termsChecked: false,
      checkedMinAge: true,
      error: false,
      attemptedSubmit: false,
    };
    this.handleCheck = this.handleCheck.bind(this);
    this.handleCheckMinAge = this.handleCheckMinAge.bind(this);
    this.handleEmailCheck = this.handleEmailCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.cleanFields = this.cleanFields.bind(this);
    this.isValidPhone = this.isValidPhone.bind(this);
    this.formatPhoneNumber = this.formatPhoneNumber.bind(this);
    this.handleChangeDoB = this.handleChangeDoB.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.checkAge = this.checkAge.bind(this);
    this.handleScrollTo = this.handleScrollTo.bind(this);
  }

  cleanFields() {
    var inputZip = document.getElementById('contestZipCode');
    $(inputZip).val(
      $(inputZip)
        .val()
        .replaceAll(/[^0-9]/g, '')
    );
  }

  isValidPhone(testString) {
    return !isNaN(testString * 1) && testString.length == 10;
  }

  handleChangeDoB(date) {
    this.setState({ dob: date });
    this.handleInput(date, 'dob');
  }

  formatPhoneNumber(inputString) {
    var returnString = '';
    if (inputString.length > 0) {
      returnString = `(${inputString.substring(0, 3)}`;
    }
    if (inputString.length > 3) {
      returnString += `) ${inputString.substring(3, 6)}`;
    }
    if (inputString.length > 6) {
      returnString += `-${inputString.substring(6)}`;
    }
    return returnString;
  }

  handleInput(event, name) {
    const val = name === 'dob' ? event : event.target.value;
    const ansObj = { ...this.state.formData };
    const validation = validateInputOnInput(val, name);
    ansObj[name].value = validation.value;
    ansObj[name].valid = name === 'dob' ? this.checkAge(val) : true;
    if (name === 'dob' && !this.checkAge(val)) {
      ansObj[name].errorMsg = 'Age is too young to enter contest.';
    }
    this.setState({ formData: ansObj });
  }

  handleInputBlur(e, name, required) {
    const val = e.target.value;
    const ansObj = { ...this.state.formData };
    const validation = validateInputOnBlur(val, name, required);
    const isRequired = name.includes('0') ? true : required;
    ansObj[name].valid =
      name === 'dob' ? this.checkAge(val) : isRequired ? validation.valid : val.length > 0 ? validation.valid : true;
    ansObj[name].errorMsg = validation.errorMsg;
    ansObj[name].required = isRequired;
    this.setState({ formData: ansObj });
  }

  handleCheck() {
    this.setState({ termsChecked: !this.state.termsChecked });
    if (this.props.widgetData.requireTerms) {
      var agreeToTermsInput = document.getElementById('agreeToTerms').parentElement.parentElement;
      if (this.state.termsChecked) {
        !agreeToTermsInput.classList.contains('has-error') ? agreeToTermsInput.classList.add('has-error') : '';
      } else {
        agreeToTermsInput.classList.contains('has-error') ? agreeToTermsInput.classList.remove('has-error') : '';
      }
    }
  }

  handleCheckMinAge() {
    this.setState({ checkedMinAge: !this.state.checkedMinAge });
    if (this.props.widgetData.confirmAge) {
      var minimumAgeInput = document.getElementById('minimumAge').parentElement.parentElement;
      if (this.state.checkedMinAge) {
        !minimumAgeInput.classList.contains('has-error') ? minimumAgeInput.classList.add('has-error') : '';
      } else {
        minimumAgeInput.classList.contains('has-error') ? minimumAgeInput.classList.remove('has-error') : '';
      }
    }
  }

  handleEmailCheck(e) {
    this.setState({ receiveEmails: e.target.checked });
  }

  checkAge(val) {
    var today = new Date();
    var birthDate = new Date(val);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age < parseInt(this.props.widgetData.minimumAge) || val === '') {
      return false;
    } else return true;
  }

  handleScrollTo(hasError) {
    if (hasError) {
      const firstErrorInput = document.getElementsByClassName('form-group invalid');
      if (this.props.passedAppFunctions.siteFormat === 'desktop') {
        $('html,body').animate({ scrollTop: $(firstErrorInput).offset().top - 90 }, 'slow');
      } else {
        $('html,body').animate({ scrollTop: $(firstErrorInput).offset().top }, 'slow');
      }
    } else {
      $('html,body').animate({ scrollTop: 0 }, 'slow');
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    let formValid = true;

    this.setState({ attemptedSubmit: true });
    const answersObj = this.state.formData;
    Object.keys(this.state.formData).forEach((q) => {
      if (
        answersObj[q].required === true &&
        (answersObj[q].value === undefined ||
          answersObj[q].value === 0 ||
          answersObj[q].value === '*' ||
          answersObj[q].value === '')
      ) {
        const ansObj = { ...answersObj };
        ansObj[q].valid = false;
        ansObj[q].errorMsg = answersObj[q].errorMsg ? answersObj[q].errorMsg : errorTypesText.required;
        this.setState({ formData: ansObj });
        formValid = false;
      }
      if (answersObj[q].valid === false) {
        const ansObj = { ...answersObj };
        ansObj[q].valid = false;
        ansObj[q].errorMsg = answersObj[q].errorMsg ? answersObj[q].errorMsg : errorTypesText.required;
        this.setState({ formData: ansObj });
        formValid = false;
      }
    });

    if (!this.state.checkedMinAge) {
      formValid = false;
    }

    if (this.props.widgetData.requireTerms) {
      var agreeToTermsInput = document.getElementById('agreeToTerms').parentElement.parentElement;
      if (!this.state.termsChecked) {
        formValid = false;
        !agreeToTermsInput.classList.contains('has-error') ? agreeToTermsInput.classList.add('has-error') : '';
      } else {
        agreeToTermsInput.classList.contains('has-error') ? agreeToTermsInput.classList.remove('has-error') : '';
      }
    }

    if (this.props.widgetData.confirmAge) {
      var minimumAgeInput = document.getElementById('minimumAge').parentElement.parentElement;
      if (!this.state.checkedMinAge) {
        !minimumAgeInput.classList.contains('has-error') ? minimumAgeInput.classList.add('has-error') : '';
      } else {
        minimumAgeInput.classList.contains('has-error') ? minimumAgeInput.classList.remove('has-error') : '';
      }
    }

    const data = {};
    data['restrictions'] = this.state.restrictions;
    data['contestId'] = this.state.contestId;

    Object.keys(this.state.formData).forEach((key) => {
      if (key === 'dob') {
        data[key] = Date.parse(this.state.formData[key].value);
      } else {
        data[key] = this.state.formData[key].value;
      }
    });

    data['receiveEmails'] = this.state.receiveEmails;

    if (formValid) {
      axios
        .post('/wcs/resources/store/301/contest', data, { withCredentials: false })
        .then((res) => {
          const msg = res.data.message;
          const successBox = document.getElementById('contest-success');
          successBox.innerText = msg;
          successBox.style.display = 'block';
          this.handleScrollTo(false);
        })
        .catch((error) => {
          const errRequestObj = error.request?.response;
          let err = undefined;
          if (errRequestObj) {
            const resp = JSON.parse(errRequestObj);
            err = resp.errors[0].errorMessage.split(':')[1];
          }
          setTimeout(() => {
            this.handleScrollTo(false);
          }, 100);
        });
    } else {
      setTimeout(() => {
        this.handleScrollTo(true);
      }, 400);
    }
  }

  render() {
    return (
      <div className='contest-form'>
        {this.props.widgetData.contestActive ? (
          <form id='contestForm' className='mx-auto col-xl-8 col-lg-10 col-md-10'>
            <input type='hidden' id='contest-address-2' name='address2' />
            <div className='wrapper'>
              <div>
                <div id='contest-contestant'>
                  <h1>Contestant Information</h1>
                  <div id='contestError' className='contest-error' style={{ display: 'none' }}></div>
                  <div className='contestSuccess' id='contest-success' style={{ display: 'none' }}></div>
                  <div>
                    <p className='reqdMessage'>* Indicates a required field</p>
                  </div>
                  <div className={!this.state.formData.email.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contest-verify-email' className='control-label sr-only'>
                      Email
                    </label>
                    <input
                      name='email'
                      placeholder='Email*'
                      size='30'
                      maxLength='50'
                      value={this.state.formData.email.value}
                      type='email'
                      id='contest-verify-email'
                      className='form-control'
                      data-validate='email'
                      onInput={(e) => this.handleInput(e, 'email')}
                      onBlur={(e) => this.handleInputBlur(e, 'email', true)}
                      required
                    />
                    {!this.state.formData.email.valid ? (
                      <span id='invalidEmail' className='error-tip'>
                        {this.state.formData.email.errorMsg
                          ? this.state.formData.email.errorMsg
                          : 'Please enter a valid email.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={!this.state.formData.firstName.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contest-first-name' className='control-label sr-only'>
                      First Name
                    </label>
                    <input
                      name='firstName'
                      placeholder='First name*'
                      value={this.state.formData.firstName.value}
                      size='30'
                      maxLength='16'
                      type='text'
                      id='contest-first-name'
                      className='form-control'
                      data-validate='name'
                      data-toggle='tooltip'
                      data-placement='top'
                      onInput={(e) => this.handleInput(e, 'firstName')}
                      onBlur={(e) => this.handleInputBlur(e, 'firstName', true)}
                      required
                    />
                    {!this.state.formData.firstName.valid ? (
                      <span id='invalidFirstName' className='error-tip'>
                        {this.state.formData.firstName.errorMsg
                          ? this.state.formData.firstName.errorMsg
                          : 'Please enter a valid first name.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={!this.state.formData.lastName.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contest-last-name' className='control-label sr-only'>
                      Last Name
                    </label>
                    <input
                      size='30'
                      maxLength='20'
                      value={this.state.formData.lastName.value}
                      name='lastName'
                      placeholder='Last name*'
                      type='text'
                      id='contest-last-name'
                      className='form-control'
                      data-validate='name'
                      data-toggle='tooltip'
                      data-placement='top'
                      onInput={(e) => this.handleInput(e, 'lastName')}
                      onBlur={(e) => this.handleInputBlur(e, 'lastName', true)}
                      required
                    />
                    {!this.state.formData.lastName.valid ? (
                      <span id='invalidLastName' className='error-tip'>
                        {this.state.formData.lastName.errorMsg
                          ? this.state.formData.lastName.errorMsg
                          : 'Please enter a valid last name.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  {this.props.widgetData.requestBday ? (
                    <div className={!this.state.formData.dob.valid ? 'form-group invalid' : 'form-group'}>
                      <label htmlFor='contest-dob' className='control-label sr-only'>
                        Birth date*
                      </label>
                      <DatePicker
                        wrapperClassName='datePicker'
                        selected={this.state.dob}
                        onChange={(e) => this.handleChangeDoB(e)}
                        onBlur={(e) => this.handleInputBlur(e, 'dob', true)}
                        maxDate={new Date()}
                        popperPlacement='bottom'
                        id='contest-dob'
                        nextMonthButtonLabel=''
                        previousMonthButtonLabel=''
                        placeholderText={'Birth Date*'}
                        // className="form-control"
                        showYearDropdown={true}
                        className={!this.state.formData.dob.valid ? 'invalid form-control required' : 'form-control'}
                      />
                      {!this.state.formData.dob.valid ? (
                        <span className='error-tip'>
                          {this.state.formData.dob.errorMsg
                            ? this.state.formData.dob.errorMsg
                            : 'Please enter a valid date of birth.'}
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    ''
                  )}

                  <div className={!this.state.formData.intl.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='state' className='control-label sr-only'>
                      Do you live in the United States?
                    </label>
                    <select
                      id='contest-country'
                      name='intl'
                      className='form-control disregard-dropdown'
                      data-validate='required'
                      data-toggle='tooltip'
                      value={this.state.formData.intl.value}
                      data-placement='top'
                      required
                      onChange={(e) => this.handleInput(e, 'intl')}
                      onBlur={(e) => this.handleInputBlur(e, 'intl', true)}
                    >
                      <option value='' selected disabled hidden>
                        Do you live in the United States?*
                      </option>
                      <option value='N'> Yes </option>
                      <option value='Y'> No </option>
                    </select>
                    {!this.state.formData.intl.valid ? (
                      <span id='invalidEmail' className='error-tip'>
                        {this.state.formData.intl.errorMsg
                          ? this.state.formData.intl.errorMsg
                          : 'Please select an option.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={!this.state.formData.address1.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contest-address-1' className='control-label sr-only'>
                      Address
                    </label>
                    <input
                      type='text'
                      id='contest-address-1'
                      className='form-control'
                      name='address1'
                      placeholder='Address*'
                      size='60'
                      maxLength='60'
                      value={this.state.formData.address1.value}
                      data-validate='required, maxLength(60)'
                      data-toggle='tooltip'
                      data-placement='top'
                      onChange={(e) => this.handleInput(e, 'address1')}
                      onBlur={(e) => this.handleInputBlur(e, 'address1', true)}
                      required
                    />
                    {!this.state.formData.address1.valid ? (
                      <span id='invalidEmail' className='error-tip'>
                        {this.state.formData.address1.errorMsg
                          ? this.state.formData.address1.errorMsg
                          : 'Please enter a valid address.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={!this.state.formData.city.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contest-city' className='control-label sr-only'>
                      City
                    </label>
                    <input
                      type='text'
                      id='contest-city'
                      className='form-control'
                      name='city'
                      placeholder='City*'
                      value={this.state.formData.city.value}
                      size='30'
                      data-toggle='tooltip'
                      data-placement='top'
                      required
                      onChange={(e) => this.handleInput(e, 'city')}
                      onBlur={(e) => this.handleInputBlur(e, 'city', true)}
                    />
                    {!this.state.formData.city.valid ? (
                      <span id='invalidEmail' className='error-tip'>
                        {this.state.formData.city.errorMsg
                          ? this.state.formData.city.errorMsg
                          : 'Please enter a valid city.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={!this.state.formData.stateCode.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contestState' className='control-label sr-only'>
                      State
                    </label>
                    <select
                      id='contestState'
                      name='stateCode'
                      className='form-control disregard-dropdown'
                      data-validate='required'
                      data-toggle='tooltip'
                      value={this.state.formData.stateCode.value}
                      data-placement='top'
                      onChange={(e) => this.handleInput(e, 'stateCode')}
                      onBlur={(e) => this.handleInputBlur(e, 'stateCode', true)}
                    >
                      <option value='' selected disabled hidden>
                        State*
                      </option>
                      {this.props?.passedAppFunctions?.statesList?.map((a) => {
                        return (
                          <option value={Object.keys(a)} key={`state-option-${Object.keys(a)}`}>
                            {Object.values(a)}
                          </option>
                        );
                      })}
                    </select>
                    {!this.state.formData.stateCode.valid ? (
                      <span id='invalidEmail' className='error-tip'>
                        {this.state.formData.stateCode.errorMsg
                          ? this.state.formData.stateCode.errorMsg
                          : 'Please select a state.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={!this.state.formData.zip.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contestZipCode' className='control-label sr-only'>
                      Zip Code
                    </label>
                    <input
                      type='text'
                      id='contestZipCode'
                      className='form-control'
                      data-validate='required,zip'
                      name='zip'
                      placeholder='Zip Code*'
                      value={this.state.formData.zip.value}
                      size='30'
                      maxLength='5'
                      pattern='[0-9]*'
                      data-toggle='tooltip'
                      data-placement='top'
                      onInput={this.cleanFields.bind(this)}
                      onChange={(e) => this.handleInput(e, 'zip')}
                      onBlur={(e) => this.handleInputBlur(e, 'zip', true)}
                    />
                    {!this.state.formData.zip.valid ? (
                      <span id='invalidEmail' className='error-tip'>
                        {this.state.formData.zip.errorMsg
                          ? this.state.formData.zip.errorMsg
                          : 'Please enter a valid zip code.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className={!this.state.formData.phone.valid ? 'form-group invalid' : 'form-group'}>
                    <label htmlFor='contest-phone' className='control-label sr-only'>
                      Phone Number
                    </label>
                    <input
                      type='tel'
                      id='contest-phone'
                      className='form-control'
                      maxLength='14'
                      name='phone'
                      placeholder='Phone Number*'
                      value={this.formatPhoneNumber(this.state.formData.phone.value)}
                      data-validate='phone'
                      data-toggle='tooltip'
                      data-placement='top'
                      required
                      onChange={(e) => this.handleInput(e, 'phone')}
                      onBlur={(e) => this.handleInputBlur(e, 'phone', true)}
                      autoComplete='off'
                    />
                    {!this.state.formData.phone.valid ? (
                      <span id='invalidEmail' className='error-tip'>
                        {this.state.formData.phone.errorMsg
                          ? this.state.formData.phone.errorMsg
                          : 'Please enter a valid phone number.'}
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  {this.props.widgetData.options.map((option, index) =>
                    option.type == 'dropdown' ? (
                      <div
                        className={option.required && this.state.attemptedSubmit ? 'form-group required' : 'form-group'}
                        key={option.type + '-' + index}
                      >
                        <label
                          htmlFor={'response' + (index + 1)}
                          className='control-label sr-only'
                          key={`label-${index}`}
                        >
                          {option.label}
                        </label>
                        <select
                          id={'response' + (index + 1)}
                          name={'response' + (index + 1)}
                          data-validate={option.required ? 'required' : ''}
                          className='form-control'
                          data-toggle='tooltip'
                          value={this.state.formData[`response${index + 1}`].value}
                          data-placement='top'
                          required={option.required}
                          onChange={(e) => this.handleInput(e, `response${index + 1}`)}
                          onBlur={(e) => this.handleInputBlur(e, `response${index + 1}`, option.required)}
                          key={`select-${index}`}
                        >
                          <option value='' selected hidden>
                            {option.label + (option.required ? '*' : '')}
                          </option>
                          {option.values.length > 1
                            ? option.values.map((value, indx) => (
                                <option value={value} key={value}>
                                  {value}
                                </option>
                              ))
                            : ''}
                        </select>
                        {!this.state.formData[`response${index + 1}`].valid &&
                        this.state.formData[`response${index + 1}`].required ? (
                          <span id='invalidEmail' className='error-tip'>
                            {this.state.formData[`response${index + 1}`].errorMsg
                              ? this.state.formData[`response${index + 1}`].errorMsg
                              : 'Please select an option.'}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    ) : (
                      <div
                        className={option.required && this.state.attemptedSubmit ? 'form-group required' : 'form-group'}
                        key={option.type + '-' + index}
                      >
                        <label
                          htmlFor={'response' + (index + 1)}
                          className='control-label sr-only'
                          key={`label-${index}`}
                        >
                          {option.label}
                        </label>
                        <input
                          id={'response' + (index + 1)}
                          type='text'
                          data-validate={option.required ? 'required' : ''}
                          required={option.required}
                          className='form-control'
                          name={'response' + (index + 1)}
                          placeholder={option.label + (option.required ? '*' : '')}
                          value={this.state.formData[`response${index + 1}`].value}
                          data-toggle='tooltip'
                          data-placement='top'
                          onChange={(e) => this.handleInput(e, `response${index + 1}`)}
                          onBlur={(e) => this.handleInputBlur(e, `response${index + 1}`, option.required)}
                          key={`input-${index}`}
                        />
                        {!this.state.formData[`response${index + 1}`].valid &&
                        this.state.formData[`response${index + 1}`].required ? (
                          <span id='invalidEmail' className='error-tip'>
                            {this.state.formData[`response${index + 1}`].errorMsg
                              ? this.state.formData[`response${index + 1}`].response1.errorMsg
                              : 'Please enter a response.'}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    )
                  )}
                  <div className='form-group' style={{ display: 'none' }}>
                    <input
                      type='text'
                      value={this.state.formData.response1}
                      size='30'
                      maxLength='28'
                      data-placement='top'
                      onChange={(e) => this.handleInput(e, 'response1')}
                    />
                    <input
                      type='text'
                      value={this.state.formData.response2}
                      size='30'
                      maxLength='28'
                      data-placement='top'
                      onChange={(e) => this.handleInput(e, `response2`)}
                    />
                  </div>
                </div>
              </div>

              <div id='contest-footer'>
                <div className='d-flex flex-column'>
                  <div className='flex flex-row'>
                    <div className='dillards-emails'>
                      <label id='opt-in-label' htmlFor='special-offer-optin' className='control-label'>
                        <input
                          name='receiveEmails'
                          id='special-offer-optin'
                          type='checkbox'
                          className='form-control'
                          data-novalidation=''
                          value={this.state.receiveEmails}
                          onChange={this.handleEmailCheck.bind(this)}
                          checked={this.state.receiveEmails}
                        />
                        <span>Sign me up for Dillard&apos;s emails</span>
                      </label>
                    </div>
                    {this.props.widgetData.requireTerms ? (
                      <div className='required'>
                        <label
                          htmlFor='agreeToTerms'
                          className={
                            !this.state.checked && this.state.attemptedSubmit ? 'form-group invalid' : 'form-group'
                          }
                        >
                          <input
                            name='consent'
                            className='form-control'
                            type='checkbox'
                            id='agreeToTerms'
                            defaultChecked={this.state.checked}
                            onChange={this.handleCheck.bind(this)}
                          />
                          <span>
                            <span className='requiredAsterisk'>* </span>I have read the Terms &amp; Conditions
                          </span>
                        </label>
                        {!this.state.checked && this.state.attemptedSubmit ? (
                          <span className='error-tip' id='agreeToTerms-error-message'>
                            {'This field is required.'}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                    {this.props.widgetData.confirmAge ? (
                      <div className='required'>
                        <label
                          htmlFor='minimumAge'
                          className={
                            !this.state.checkedMinAge && this.state.attemptedSubmit
                              ? 'form-group invalid'
                              : 'form-group'
                          }
                        >
                          <input
                            name='minimumAge'
                            className='form-control'
                            type='checkbox'
                            id='minimumAge'
                            defaultChecked={this.state.checkedMinAge}
                            onChange={this.handleCheckMinAge.bind(this)}
                          />
                          <span>
                            <span className='requiredAsterisk'>* </span>I am {this.props.widgetData.minimumAge} or older{' '}
                          </span>
                        </label>
                        {!this.state.checkedMinAge && this.state.attemptedSubmit ? (
                          <span className='error-tip' id='minimumAge-error-message'>
                            {'This field is required.'}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group d-flex flex-column'>
                    <button
                      href='javascript:void(0)'
                      id='contest-submit'
                      type='button'
                      onClick={this.handleSubmit.bind(this)}
                      className='btn btn-primary pull-right w-25 mt-3'
                    >
                      Submit
                    </button>
                    <p className='mb-2 mt-3 font-weight-bold'>
                      Must be {this.props.widgetData.minimumAge} or older to enter*
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        ) : (
          ''
        )}
        {this.props.widgetData.beforeStartDate ? (
          <div id='beforeStartDate'>
            <h1>Sorry, this contest is currently not accepting entries.</h1>
          </div>
        ) : (
          ''
        )}

        {this.props.widgetData.afterEndDate ? (
          <div id='afterEndDate'>
            <h1>Sorry, this contest has ended.</h1>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default Contest;
